<script setup lang="ts">
import { resetWizardDismissal, useWizardAudience } from '@/composables/use-initialization-wizard';
import { LanguageSwitcher, usePrivacyConfig } from '@fondationcss/ui';
import { translate } from '@fondationcss/sdk';

const isAdmin = useWizardAudience();

const externalUrl = 'https://heuriqa.byrnu.com/boards/parcours';

const openWizard = () => {
  resetWizardDismissal()
};

const { privacyLinkHref, privacyLinkIsExternal } = usePrivacyConfig();
</script>

<template>
  <v-list class="py-0">
    <v-list-item rounded="0">
      <LanguageSwitcher />
    </v-list-item>

    <v-list-item to="/docs/NotesDeVersion" color="primary" rounded="0">
      <template v-slot:prepend>
        <v-icon size="small">fas fa-circle-info</v-icon>
      </template>
      <v-list-item-title class="text-body-2">{{ translate('parcours.profile.releaseNotes') }}</v-list-item-title>
    </v-list-item>

    <v-list-item :href="externalUrl" target="_blank" rel="noopener" color="primary" rounded="0">
      <template v-slot:prepend>
        <v-icon size="small">fas fa-lightbulb</v-icon>
      </template>
      <v-list-item-title class="text-body-2">{{ translate('parcours.profile.suggestionsAndIdeas') }}</v-list-item-title>
    </v-list-item>

    <!-- Configurer l'application est un travail d'administrateur : l'entrée n'était offerte à
         personne en particulier, et un élève y ouvrait un assistant vide (#661). -->
    <v-list-item v-if="isAdmin" color="primary" rounded="0" @click="openWizard">
      <template v-slot:prepend>
        <v-icon size="small">fas fa-clipboard-list</v-icon>
      </template>
      <v-list-item-title class="text-body-2">{{ translate('parcours.profile.initialSetupWizard') }}</v-list-item-title>
    </v-list-item>

    <v-list-item
      v-if="privacyLinkHref && privacyLinkIsExternal"
      :href="privacyLinkHref"
      target="_blank"
      rel="noopener noreferrer"
      color="primary"
      rounded="0"
    >
      <template v-slot:prepend>
        <v-icon size="small">fas fa-shield-halved</v-icon>
      </template>
      <v-list-item-title class="text-body-2">{{ translate('parcours.profile.privacyPolicy') }}</v-list-item-title>
    </v-list-item>
    <v-list-item
      v-else-if="privacyLinkHref"
      :to="privacyLinkHref"
      color="primary"
      rounded="0"
    >
      <template v-slot:prepend>
        <v-icon size="small">fas fa-shield-halved</v-icon>
      </template>
      <v-list-item-title class="text-body-2">{{ translate('parcours.profile.privacyPolicy') }}</v-list-item-title>
    </v-list-item>
  </v-list>
</template>
